import { Autocomplete, Box, Button, TextField, Typography } from "@mui/material";
import {
  DataGrid,
  GridLinkOperator,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";
import api from "../../../../components/services/api";

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        width: "100%",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(",")
            .map((value) => value.trim())
            .filter((value) => value !== "")
        }
      />
    </Box>
  );
}

// 3 กลุ่มย่อยของ Import (รวมกัน = Import ในหน้า list) — ดู stockContainerDetailBreakdown ฝั่ง API
const MODES = [
  { key: "stock", label: "ตู้เปล่า (Empty)" },
  { key: "inuse", label: "ทำงาน (Stuffing)" },
  { key: "staged", label: "ตู้หนัก (Laden)" },
];

export default function ContainerStock() {
  const { id } = useParams();
  const history = useHistory();
  const [rows, setRows] = useState([]); // ทุกกลุ่มรวมกัน (= Import)
  const [summary, setSummary] = useState({
    Import: 0,
    Counts: { stock: 0, inuse: 0, staged: 0 },
  });
  // เก็บแค่ id ที่ติ๊ก — Booking ดึงจาก rows ตอนกด Save (ติ๊กก่อนแล้วค่อยเลือก Booking ก็ไม่หาย)
  const [selectionModel, setSelectionModel] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState("stock");

  const [detailBooking, setDetailBooking] = useState([]);
  const getData = async () => {
    setLoading(true);
    try {
      const res = await api.get(`api/stock/detail/breakdown/${id}`);
      setRows(res.data?.Rows || []);
      setSummary({
        Import: res.data?.Import || 0,
        Counts: res.data?.Counts || { stock: 0, inuse: 0, staged: 0 },
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const getDetailBooking = async () => {
    try {
      const data = await api.get(`api/stock/detail/booking/${id}`);
      setDetailBooking(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
    getDetailBooking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // สลับกลุ่ม = กรองในเครื่อง (ไม่ยิง API ใหม่)
  const displayRows = rows.filter((r) => r.Bucket === viewMode);

  const handleSubmit = async () => {
    const selectedIDs = new Set(selectionModel);
    const body = {
      LinersId: id,
      ContainerList: displayRows.filter((row) =>
        selectedIDs.has(row.StockMovementID)
      ),
    };
    await api.post(`api/stock/update/stock`, body).then((res) => {
      if (res?.meta?.status == true) {
        Swal.fire("อัพเดทสำเร็จ", "ส่งข้อมูลสำเร็จ", "success");
        // โหลดใหม่ให้เห็นค่าที่บันทึกจริง (หลังบันทึก id ของแถวอาจเปลี่ยนเป็นแถว In Stock)
        setSelectionModel([]);
        getData();
      }
    });
  };
  const columns = [
    { field: "ContainerStockType", headerName: "Status", width: 100 },
    { field: "CurrentStatus", headerName: "สถานะปัจจุบัน", width: 130 },
    { field: "ContainerNo", headerName: "Container No.", width: 200 },
    { field: "Size", headerName: "Size", width: 100 },
    {
      field: "BookingNo",
      headerName: "Booking No.",
      width: 250,
      renderCell: (params) => {
        // แก้ Booking ได้เฉพาะตู้เปล่าในลาน
        if (viewMode !== "stock") {
          return <>{params?.row?.BookingNo}</>;
        }
        return (
          <>
            <Autocomplete
              size="small"
              id="combo-box-demo"
              options={detailBooking}
              sx={{ width: "100%" }}
              value={params?.row?.BookingNo}
              onChange={(e, newValue) => {
                setRows((prev) =>
                  prev.map((y) =>
                    y?.ContainerNo === params?.row?.ContainerNo
                      ? { ...y, BookingNo: newValue }
                      : y
                  )
                );
              }}
              renderInput={(params) => (
                <TextField {...params} label="Booking No." />
              )}
            />
          </>
        );
      },
    },
    { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 200 },
    { field: "InboundGateOut", headerName: "Gate OUT", width: 150 },
    { field: "InboundGateIn", headerName: "Gate IN", width: 150 },
    { field: "VoyIn", headerName: "VOY IN", width: 150 },
    {
      field: "InboundETAGateIn",
      headerName: "ETA Gate IN",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "PickupDate",
      headerName: "Pick-up Date",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "ReturnDate",
      headerName: "Return Date",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    { field: "VoyOut", headerName: "VOY OUT", width: 150 },
    {
      field: "OutboundETDGateOut",
      headerName: "ETD Gate OUT",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "OutboundETAGateIn",
      headerName: "ETA Gate IN",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
  ];
  return (
    <>
      <Box sx={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        {MODES.map((m) => (
          <Button
            key={m.key}
            variant={viewMode === m.key ? "contained" : "outlined"}
            style={{
              background: viewMode === m.key ? "#80c340" : "transparent",
              color: viewMode === m.key ? "#fff" : "#80c340",
              borderColor: "#80c340",
            }}
            onClick={() => setViewMode(m.key)}
          >
            {m.label} ({summary.Counts?.[m.key] ?? 0})
          </Button>
        ))}
      </Box>
      <Typography variant="body2" sx={{ marginTop: "10px", color: "#666" }}>
        Import {summary.Import} = ตู้เปล่า {summary.Counts?.stock ?? 0} + ทำงาน{" "}
        {summary.Counts?.inuse ?? 0} + ตู้หนัก {summary.Counts?.staged ?? 0}
      </Typography>
      <Box
        sx={{
          height: 630,
          width: "100%",
          marginTop: "10px",
        }}
      >
        <DataGrid
          loading={loading}
          getRowId={(r) => r.StockMovementID}
          rows={displayRows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          hideFooterSelectedRowCount
          disableColumnFilter
          disableSelectionOnClick
          disableColumnMenu
          checkboxSelection={viewMode === "stock"}
          disableRowSelectionOnClick
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterLogicOperator: GridLinkOperator.Or,
              },
            },
          }}
          components={{ Toolbar: QuickSearchToolbar }}
          selectionModel={selectionModel}
          onSelectionModelChange={(ids) => setSelectionModel(ids)}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "25px" }}>
        <Button
          sx={{ width: 80 }}
          type="button"
          variant="outlined"
          style={{
            color: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={history.goBack}
        >
          close
        </Button>
        {viewMode === "stock" && (
          <Button
            sx={{ width: 80 }}
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        )}
      </Box>
    </>
  );
}
